import { protectedService } from "@services/authentication/protected"
import { Navigate } from "react-router"
import { useEffect, useState } from "react"

const PublicRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null)

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        await protectedService()
        setIsAuthenticated(true)
      } catch (error) {
        setIsAuthenticated(false)
      }
    }
    verifyAuth()
  }, [])

  if (isAuthenticated === null) {
    return null
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }

  return children
}

export default PublicRoute
